const EditContentButtonIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      fill="#000"
      fillRule="evenodd"
      d="M20.75 12V6A4.75 4.75 0 0 0 16 1.25H6A4.75 4.75 0 0 0 1.25 6v10A4.75 4.75 0 0 0 6 20.75h6a.75.75 0 0 0 0-1.5H6A3.247 3.247 0 0 1 2.75 16V6A3.247 3.247 0 0 1 6 2.75h10A3.247 3.247 0 0 1 19.25 6v6a.75.75 0 0 0 1.5 0"
      clipRule="evenodd"
    />
    <path fill="#4079F5" d="m16 22-2.5-8.5L22 16l-3.5 2.5z" />
    <path
      fill="#000"
      fillRule="evenodd"
      d="m20.816 14.411-5.625-1.875a2.099 2.099 0 0 0-2.654 2.654l1.875 5.625a2.098 2.098 0 0 0 3.9.205l.847-1.862 1.862-.846a2.1 2.1 0 0 0-.205-3.901m-6.1-.452 5.626 1.875a.6.6 0 0 1 .058 1.112l-2.118.963a.75.75 0 0 0-.372.372l-.963 2.118a.598.598 0 0 1-1.112-.058l-1.875-5.625a.6.6 0 0 1 .145-.612.6.6 0 0 1 .612-.145M6 6.75h3a.75.75 0 0 0 0-1.5H6a.75.75 0 0 0 0 1.5M6 9.75h8a.75.75 0 0 0 0-1.5H6a.75.75 0 0 0 0 1.5M6 12.75h4a.75.75 0 0 0 0-1.5H6a.75.75 0 0 0 0 1.5"
      clipRule="evenodd"
    />
  </svg>
)
export default EditContentButtonIcon
